

export function translatePermissoes(permissoes)
{
    if (!permissoes) { console.log("Erro: permissoes undefined em translatePermissoes") ; return }
    if (permissoes.length <= 0) { console.log("Erro: nenhuma permissão em translatePermissoes") ; return }

    const dictPerm =
    {
        ROLE_ANALISTA: "analista",
        ROLE_USER: "usuário",
        ROLE_TESTER: "testador",
        ROLE_GESTOR: "gestor",
        ROLE_ADMIN: "administrador"
    }
    
    let permissoesLegiveis = permissoes.slice()
    permissoesLegiveis = permissoesLegiveis.map(p => p = Object.keys(dictPerm).includes(p) ? dictPerm[p] + ", " : p)
    permissoesLegiveis[permissoesLegiveis.length - 1] = permissoesLegiveis[permissoesLegiveis.length - 1].replace(", ", "")

    return permissoesLegiveis
}